module.exports = __webpack_public_path__ + "static/Kuba_2-b1223f23c79209f91da4596f91fad2ae.jpg";